import { useTranslation } from 'react-i18next';
import * as yup from 'yup';

export const useSchemaResignMember = () => {
  const { t } = useTranslation();
  const requiredMessage = t('common:validationMessages.required');

  const resignMemberSchema = yup.object().shape({
    date: yup.date().required(requiredMessage),
    cause: yup
      .object()
      .shape({
        name: yup.string(),
        value: yup.string(),
      })
      .required(requiredMessage)
      .default(undefined), // Ensure default is undefined or an empty object
  });

  return resignMemberSchema;
};
